import { useState } from 'react';

import Loader from '../Loader/Loader';
import UserPanelHeadingText from '../../atoms/UserPanel/UserPanelHeadingText';

import { StyledText } from '../../atoms/Text/StyledText';
import { StyledUserPanelPermissions } from './UserPanelPermissions.styles';
import {
    StyledLoaderWrapper,
    StyledGlobalHeadingWrapper,
    StyledGlobalScrollWrapper,
} from '../../../styles/sharedStyles';

import { getString } from '../../../strings';
import { listUsers } from '../../../logic/requests/students';
import { cebulaCompare } from '../../../logic/arrays';

import useScrollBar from '../../../logic/hooks/useScrollBar';
import { useQuery } from '@tanstack/react-query';
import { getPermissions } from '../../../logic/requests/permissions';
import UserPanelPermissionsComponent from './UserPanelPermissionsComponent';

const UserPanelPermissions = () => {
    const { isScrollBar, scrollElement, trigger } = useScrollBar();

    const [err, setErr] = useState(false);

    const { data: permissions } = useQuery(['permissions', 'all'], getPermissions, {
        onError: () => setErr(true),
    });

    return (
        <StyledUserPanelPermissions>
            {err ? (
                <StyledLoaderWrapper>
                    <StyledText
                        hasdeclaredpadding="20px 20px 30px 0"
                        hasdeclaredfontsize="36px"
                        hasdeclaredfontweight="700"
                        hasdeclaredlineheight="1.4em"
                        as="h2"
                    >
                        {getString('blad_wczytywania')}:
                    </StyledText>
                </StyledLoaderWrapper>
            ) : !(permissions) ? (
                <StyledLoaderWrapper>
                    <Loader />
                </StyledLoaderWrapper>
            ) : (
                <>
                    <StyledGlobalHeadingWrapper>
                        <UserPanelHeadingText
                            text={`${getString('UserPanelTrainerPermissions')}:`}
                        />
                    </StyledGlobalHeadingWrapper>
                    <StyledGlobalScrollWrapper $isscrollbar={isScrollBar} ref={scrollElement}>
                        <UserPanelPermissionsComponent permissions={permissions} trigger={trigger} />
                    </StyledGlobalScrollWrapper>
                </>
            )}
        </StyledUserPanelPermissions>
    );
};

export default UserPanelPermissions;
